import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; 

// Page faisant l'objet de routages
import { GestionAccesComponent } from './data-domains/acces/acces/components/gestion-acces.component';
import { GestionAccesTarifNegatifComponent } from './data-domains/acces/acces/components/gestion-acces-tarif-negatif.component';
import { GestionGroupementsParcsComponent } from './data-domains/structure/groupement-parc/components/gestion-groupements-parcs.component';
import { GestionIntervenantsComponent } from './data-domains/humain/intervenant/components/gestion-intervenants.component';
import { GestionEntreprisesComponent } from './data-domains/entreprises/components/gestion-entreprises.component';
import { DocumentSecuriteComponent } from './data-domains/document-securite/components/document-securite.component';
import { JobsSupervisionComponent } from './technical-modules/jobs/components/jobs-supervision.component';
import { MemosComponent } from './data-domains/memo/components/memos.component';
import { MessagesCollationnesComponent } from './data-domains/message-collationne/components/messages-collationnes.component';
import { ConsultationPerimetreComponent } from './data-domains/humain/responsables/components/consultation-perimetre.component';
import { ParametagePerimetresComponent } from './data-domains/perimetres/components/parametrage-perimetres.component';
import { HistoriqueTransfertsComponent } from './data-domains/humain/responsables/components/historique-transferts-component';
import { TransfertResponsabiliteComponent } from './data-domains/humain/responsables/components/transfert-responsabilite.component';

const routes: Routes = [
	{ path: 'acces', component: GestionAccesComponent },
	{ path: 'acces-tarifs-negatifs', component: GestionAccesTarifNegatifComponent },
	{ path: 'groupements-parcs', component: GestionGroupementsParcsComponent },
	{ path: 'historique-cac-cc', component: HistoriqueTransfertsComponent },
	{ path: 'connaitre-cac-cc', component: ConsultationPerimetreComponent },
	{ path: 'entreprises', component: GestionEntreprisesComponent },
	{ path: 'intervenants', component: GestionIntervenantsComponent },
	{ path: 'memos', component: MemosComponent },
	{ path: 'messages-collationnes', component: MessagesCollationnesComponent },
	{ path: 'parametrage-perimetres', component: ParametagePerimetresComponent },
	{ path: 'document-securite', component: DocumentSecuriteComponent },
	{ path: 'supervision-jobs', component: JobsSupervisionComponent },
	{ path: 'transfert-responsabilites', component: TransfertResponsabiliteComponent },

	// Pour tous les hash qui ne correspondant pas a une page Angular, il faut afficher <router-outlet> vide.
	// En effet, il peut s'agir d'une page angular-JS qui s'affiche dans son propre container, mais cela ne rend pas le hash invalide pour autant
	// Sans cette entree, ces hashs ne fonctionnent pas bien
	//
	// NB: a retirer dans il n'y aura plus aucune entree dans le router Angular-JS, au profit d'une page d'erruer
	{ path: '**' },
]; 

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {useHash: true}),
	],
	exports: [
		RouterModule,
	]
})
export class AppRoutingModule { }
